module.exports = __webpack_public_path__ + "img/down_arrow_black.5081d59b.svg";